import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import ITHero from "../components/ITHero";
import ContactForm from "../components/ContactForm";
import "../styles/services-pages.css";

const itServices = [
  {
    id: "01",
    title: { en: "Information Technology Services", ar: "خدمات تقنية المعلومات" },
    points: {
      en: [
        "Data centers & server virtualization",
        "LAN/WAN/WLAN networks",
        "Storage + Backup & Disaster Recovery",
        "Cloud hosting (AWS/Azure/GCP)",
        "Software, web/mobile apps, BI & Analytics, RPA, API integration",
        "Support contracts (AMC) + 24/7 monitoring + maintenance",
      ],
      ar: [
        "مراكز البيانات وافتراضية الخوادم",
        "شبكات LAN/WAN/WLAN",
        "التخزين + النسخ الاحتياطي والتعافي من الكوارث",
        "استضافة سحابية (AWS/Azure/GCP)",
        "تطوير البرمجيات وتطبيقات الويب/الجوال وذكاء الأعمال والتحليلات وRPA وتكامل الـ API",
        "عقود الدعم (AMC) + مراقبة 24/7 + صيانة",
      ],
    },
  },
  {
    id: "02",
    title: { en: "Low Current Systems", ar: "أنظمة التيار الخفيف" },
    points: {
      en: [
        "Safety & security: CCTV, Access Control, Intrusion, Fire Alarm",
        "Communication: VoIP, PA Systems, Video Conferencing, Wi-Fi",
        "Smart buildings: BMS, lighting, smart meters, parking",
        "AV: LED screens, smart meeting rooms, pro audio",
      ],
      ar: [
        "السلامة والأمن: كاميرات CCTV، التحكم بالدخول، أنظمة التسلل، إنذار الحريق",
        "الاتصالات: VoIP، أنظمة النداء العام PA، الاجتماعات المرئية، Wi-Fi",
        "المباني الذكية: BMS، الإضاءة، العدادات الذكية، مواقف السيارات",
        "الوسائط السمعية/البصرية: شاشات LED، غرف اجتماعات ذكية، صوت احترافي",
      ],
    },
  },
  {
    id: "03",
    title: { en: "Supply & Procurement", ar: "التوريد والمشتريات" },
    points: {
      en: [
        "IT hardware: servers, storage, switches, routers, PCs/laptops",
        "Low current: cameras, NVR/DVR, fire panels, gates, speakers",
        "Telecom: VoIP, PBX units, headsets, Wi-Fi, fiber & cabling",
      ],
      ar: [
        "معدات تقنية المعلومات: خوادم، تخزين، سويتشات، راوترات، أجهزة مكتبية/لابتوبات",
        "التيار الخفيف: كاميرات، NVR/DVR، لوحات الحريق، بوابات، سماعات",
        "الاتصالات: VoIP، مقاسم PBX، سماعات رأس، Wi-Fi، فايبر وتمديدات وكابلات",
      ],
    },
  },
  {
    id: "04",
    title: { en: "Implementation & Installation", ar: "التنفيذ والتركيب" },
    points: {
      en: [
        "Fiber optics & structured cabling",
        "Server rooms: racks, cooling, UPS",
        "Cameras, VoIP, access control setup",
        "Fire & suppression systems installation",
        "Smart halls & meeting rooms",
      ],
      ar: [
        "تمديد الألياف الضوئية والتمديدات المنظمة (Structured Cabling)",
        "غرف السيرفرات: ركات، تبريد، UPS",
        "تركيب وإعداد الكاميرات وVoIP وأنظمة التحكم بالدخول",
        "تركيب أنظمة الحريق والإطفاء",
        "قاعات ذكية وغرف اجتماعات ذكية",
      ],
    },
  },
  {
    id: "05",
    title: { en: "Managed Services", ar: "الخدمات المُدارة" },
    points: {
      en: [
        "Outsourcing for operations",
        "Network & infrastructure management",
        "Security systems monitoring",
        "Service Desk & user support",
        "Data center operations",
      ],
      ar: [
        "تشغيل مُدار (Outsourcing) للعمليات",
        "إدارة الشبكات والبنية التحتية",
        "مراقبة أنظمة الأمن",
        "مكتب خدمة (Service Desk) ودعم المستخدمين",
        "تشغيل وإدارة مراكز البيانات",
      ],
    },
  },
  {
    id: "06",
    title: { en: "Testing & Commissioning", ar: "الاختبارات والتشغيل والتسليم" },
    points: {
      en: [
        "Electrical & low-current systems testing",
        "OTDR testing for fiber & cabling",
        "Fire alarm system testing",
        "Final reports FAT/SAT",
      ],
      ar: [
        "اختبار الأنظمة الكهربائية وأنظمة التيار الخفيف",
        "اختبارات OTDR للفايبر والتمديدات",
        "اختبار أنظمة إنذار الحريق",
        "التقارير النهائية FAT/SAT",
      ],
    },
  },
  {
    id: "07",
    title: { en: "Consulting & Design", ar: "الاستشارات والتصميم" },
    points: {
      en: [
        "HLD & LLD designs",
        "Shop drawings & engineering documents",
        "Needs analysis + RFP preparation",
        "Implementation supervision & QA",
        "Assessment of existing systems & gap analysis",
      ],
      ar: [
        "تصاميم HLD وLLD",
        "مخططات تنفيذ (Shop Drawings) ووثائق هندسية",
        "تحليل الاحتياج + إعداد RFP",
        "الإشراف على التنفيذ وضمان الجودة (QA)",
        "تقييم الأنظمة الحالية وتحليل الفجوات",
      ],
    },
  },
];

function ITPage() {
  const [language, setLanguage] = useState("en");
  const [isScrolled, setIsScrolled] = useState(false);

  // Load saved language
  useEffect(() => {
    const saved = localStorage.getItem("lang");
    if (saved === "en" || saved === "ar") setLanguage(saved);
  }, []);

  // Save language on change
  useEffect(() => {
    localStorage.setItem("lang", language);
  }, [language]);

  // Header scroll effect
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));

  return (
    <div className="app" lang={language} dir="ltr">
      <Header
        language={language}
        toggleLanguage={toggleLanguage}
        isScrolled={isScrolled}
      />

      <ITHero language={language} />

      <section className="service-detail-section">
        <h2 className="detail-title">
          {language === "en"
            ? "IT, Low Current & Infrastructure Services"
            : "خدمات تقنية المعلومات والتيار الخفيف والبنية التحتية"}
        </h2>

        <p className="detail-desc">
          {language === "en"
            ? "End-to-end technology and low-current solutions covering design, supply, implementation, managed services, and commissioning."
            : "حلول تقنية متكاملة تشمل التصميم والتوريد والتنفيذ والخدمات المُدارة والاختبارات والتشغيل والتسليم."}
        </p>

        <div className="detail-grid">
          {itServices.map((service) => (
            <div key={service.id} className="detail-card">
              <div className="detail-icon">{service.id}</div>
              <h3>{service.title[language]}</h3>
              <ul>
                {service.points[language].map((p, idx) => (
                  <li key={`${service.id}-${idx}`}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <div id="contact" />
      <ContactForm language={language} />
    </div>
  );
}

export default ITPage;